function initializeScript() {
    const headings = document.querySelectorAll(
        '.bapf_head:not(.berocket_single_filter_widget_2008 .bapf_head)',
    );
    if (headings) {
        headings.forEach((heading) => {
            const nextElementSibling = heading.nextElementSibling;
            const hasActiveClass = nextElementSibling.querySelector('.checked, .current') !== null;
            if (hasActiveClass) {
                heading.classList.add('active');
                nextElementSibling.classList.add('active');
            }
            if (nextElementSibling) {
                heading.addEventListener('click', () => {
                    heading.classList.toggle('active');
                    nextElementSibling.classList.toggle('active');
                });
            }
        });
    }

    const size__heading = document.querySelector('.berocket_single_filter_widget_2008 .bapf_head');
    if (size__heading) {
        const nextElementSibling = size__heading.nextElementSibling;
        if (nextElementSibling) {
            size__heading.addEventListener('click', () => {
                size__heading.classList.toggle('active');
                nextElementSibling.classList.toggle('active');
            });
        }
    }

    const types = document.querySelectorAll('.cat__filter .bapf_body a');
    if (types) {
        types.forEach((type) => {
            let text = type.innerText;
            let updatedText = text.replace('damskie', '');
            type.innerText = updatedText;
        });
        types.forEach((type) => {
            let text = type.innerText;
            let updatedText = text.replace('męskie', '');
            type.innerText = updatedText;
        });
    }

    const wzor = document.querySelector('.berocket_single_filter_widget_991');
    const kolor = document.querySelector('.berocket_single_filter_widget_986');
    const material = document.querySelector('.berocket_single_filter_widget_917');
    const rozmiar = document.querySelector('.berocket_single_filter_widget_2008');

    [wzor, kolor, material].forEach((element) => {
        if (element) {
            const filterH = element.querySelector('.bapf_head');
            const filterB = element.querySelector('.bapf_body');
            if (filterH) {
                filterH.classList.add('active');
            }
            if (filterB) {
                filterB.classList.add('active');
            }
        }
    });

    if (window.innerWidth >= 1024) {
        if (rozmiar) {
            const filterH = rozmiar.querySelector('.bapf_head');
            const filterB = rozmiar.querySelector('.bapf_body');
            if (filterH) {
                filterH.classList.add('active');
            }
            if (filterB) {
                filterB.classList.add('active');
            }
        }
    }
}

// Wywołanie skryptu po załadowaniu strony
initializeScript();

// Sprawdzenie, czy jQuery jest dostępne
if (typeof jQuery !== 'undefined') {
    // Przypisanie funkcji initializeScript do zdarzenia ajaxSuccess
    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        // Wywołanie skryptu po zakończeniu ładowania danych AJAX
        initializeScript();
    });
}

if (window.innerWidth <= 1023) {
    // Funkcja, która aktualizuje sklonowane elementy na podstawie zmian w oryginalnych elementach
    function updateClones() {
        targetElement.appendChild(destination);

        while (destination.firstChild) {
            destination.firstChild.remove();
        }

        // Pobierz wszystkie zaznaczone elementy li
        var checkedItems = document.querySelectorAll(
            '.berocket_single_filter_widget_2008 li.checked',
        );

        // Sklonuj aktualne zaznaczone elementy li i wyświetl je w kontenerze docelowym
        checkedItems.forEach(function (item) {
            var clonedItem = item.cloneNode(true);
            destination.appendChild(clonedItem);
        });
    }

    var destination = document.createElement('ul');

    // Dodaj kontener docelowy do odpowiedniego miejsca na stronie
    var targetElement = document.getElementById('destination-container');

    const observer = new MutationObserver(updateClones);
    const targetNode = document.querySelector('.berocket_single_filter_widget_2008');
    if (targetNode) {
        observer.observe(targetNode, { childList: true, subtree: true });

        $(document).ready(function () {
            updateClones();
        });
    }
}
